import './NftItem.sass';

import React, { FC } from 'react';
import { NftItemProps } from '$core/NftList/NftItem/NftItem.interface';
import { classNames as cn } from '$utils';

export const NftItem: FC<NftItemProps> = ({ item, onClick }) => {
  return (
    <div className={cn('NftItem', { active: !!onClick })} onClick={onClick}>
      <div className="NftItem__photo">
        <img src={item.metadata.image} alt={item.metadata.name} />
      </div>
      <div className="NftItem__caption">
        <div className="NftItem__caption__description">{item.metadata.description}</div>
        <div className="NftItem__caption__name">{item.metadata.name}</div>
        <div className="NftItem__caption__number">#{item.index}</div>
      </div>
    </div>
  )
};
